import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      userInfo: {
        type: '',
      },
    },
    order: {
      id: null,
      patientId: null,
      creationDate: null,
      lastModificationDate: null,
      primaryCode: null,
      secondaryCode: null,
      shoeType: null,
      catalogType: null,
      pathologiesLeft: [],
      pathologiesRight: [],
      orderType: null,
      orderTypeMain: null,
      orderTypeVariant: null,
      orderTypeSubVariant: null,
    },
    filters: {
      companies: {
        country: '*',
        catalog: '*',
      },
      shops: {
        country: '*',
        company: undefined,
      },
      patients: {
        gender: '*',
        shop: undefined,
      },
      internalOrders: {
        type: '*',
        typeMain: '*',
        delivery: '*',
        status: '*',
        patient: undefined,
        text: '',
        module: '*',
      },
      customerOrders: {
        type: '*',
        typeMain: '*',
        delivery: '*',
        status: '*',
        patient: undefined,
        text: '',
        module: '*',
      },
    },
    language: 'it',
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang
    },
    setOrder(state, order) {
      state.order = order
    },
    setOrderId(state, value) {
      state.order.id = value
    },
    setOrderPatient(state, value) {
      state.order.patientId = value
    },
    setCreationDate(state, value) {
      state.order.creationDate = value
    },
    setLastModificationDate(state, value) {
      state.order.lastModificationDate = value
    },
    setPrimaryCode(state, value) {
      state.order.primaryCode = value
    },
    setSecondaryCode(state, value) {
      state.order.secondaryCode = value
    },
    setShoeType(state, value) {
      state.order.shoeType = value
    },
    setCatalogType(state, value) {
      state.order.catalogType = value
    },
    setPathologiesLeft(state, value) {
      state.order.pathologiesLeft = value
    },
    setPathologiesRight(state, value) {
      state.order.pathologiesRight = value
    },
    setOrderType(state, value) {
      state.order.orderType = value
    },
    setOrderTypeMain(state, value) {
      state.order.orderTypeMain = value
    },
    setOrderTypeVariant(state, value) {
      state.order.orderTypeVariant = value
    },
    setOrderTypeSubVariant(state, value) {
      state.order.orderTypeSubVariant = value
    },
    setUserMainInfo(state, value) {
      state.user.email = value.email
      state.user.language = value.language
    },
    setUserAdditionalInfo(state, value) {
      state.user.userInfo = value
    },
    setCountriesFilterShop(state, value) {
      state.filters.shops.country = value
    },
    setFiltersShops(state, value) {
      state.filters.shops.country = value.country
      state.filters.shops.company = value.company
    },
    setFiltersCompanies(state, value) {
      state.filters.companies.country = value.country
      state.filters.companies.catalog = value.catalog
    },
    setFiltersPatients(state, value) {
      state.filters.patients.gender = value.gender
      state.filters.patients.shop = value.shop
    },
    setFiltersInternalOrders(state, value) {
      state.filters.internalOrders.type = value.type
      state.filters.internalOrders.typeMain = value.typeMain
      state.filters.internalOrders.delivery = value.delivery
      state.filters.internalOrders.status = value.status
      state.filters.internalOrders.patient = value.patient
      state.filters.internalOrders.text = value.text
      state.filters.internalOrders.module = value.module
    },
    setFiltersCustomerOrders(state, value) {
      state.filters.customerOrders.type = value.type
      state.filters.customerOrders.typeMain = value.typeMain
      state.filters.customerOrders.delivery = value.delivery
      state.filters.customerOrders.status = value.status
      state.filters.customerOrders.patient = value.patient
      state.filters.customerOrders.text = value.text
      state.filters.internalOrders.module = value.module
    },
    //setCountriesFilterShop(state, value) {
    //  state.filters.shops.country = value
    //},
    emptyUser(state) {
      state.user = {
        userInfo: {
          type: '',
        },
      }
    },
  },
  actions: {
    selectLanguage({ commit }, lang) {
      commit('setLanguage', lang)
    },
    updateOrder({ commit }, order) {
      commit('setOrder', order)
    },
  },
  getters: {
    language: state => state.language,
    order: state => state.order,
    user: state => state.user,
  },
})
